'use strict';

wbApp.factory('sentEmailsSvc', ['$resource', '$translate', '$q', 'notificationSvc', 'repositorySvc',
    function ($resource, $translate, $q, notificationSvc, repositorySvc) {

        var Emails = $resource('/restapi/emails', {}, {
            'query': { method: 'GET', isArray: true },
            'getSummary': { method: 'GET', isArray: false, url: '/restapi/emails' },
            'getDetail': { method: 'GET', isArray: false, url: '/restapi/emails/:id' },
            'getStatistics': { method: 'GET', isArray: true, url: '/restapi/emails/statistics/range' }
        });

        function getSummary() {
            var deferred = $q.defer();
            var result = [];
            result.$promise = deferred.promise;

            repositorySvc.customGet('getSummary', Emails)
                .$promise.then(function (data) {
                    result.push.apply(result, data.emails);
                    deferred.resolve(result);
                },
                function (error) {
                    deferred.reject(errorResult);
                });

            return result;
        }

        function getDetail(id) {
            return repositorySvc.customGet('getDetail', Emails, { id: id });
        }

        function getStatistics(fromDate, toDate) {

            var deffered = $q.defer();

            var td = repositorySvc.customGet(
                'getStatistics',
                Emails,
                {
                    fromDateUtc: fromDate,
                    toDateUtc: toDate
                });

            td.$promise.then(function (data) {

                var cols = [];
                cols.push({
                    id: 'date',
                    label: 'Date',
                    type: 'date',
                    p: {}
                });

                cols.push({
                    id: 'c_count',
                    label: $translate.instant('TXT_DAILY_SUM'),
                    type: 'number',
                    p: {}
                });

                cols.push({
                    id: 'c_runningSum',
                    label: $translate.instant('TXT_MONTH_RUNNING_SUM'),
                    type: 'number',
                    p: {}
                });

                cols.push({
                    id: 'c_freeLimit',
                    label: $translate.instant('TXT_FREE_LIMIT'),
                    type: 'number',
                    p: {}
                });

                var rows = [];
                for (var d = 0; d < data.length; d++) {
                    var day = data[d];
                    var o = {
                        c: [
                            { v: moment(day.day).toDate() },
                            { v: day.count },
                            { v: day.runningSum },
                            { v: 2000 }
                        ]
                    };

                    rows.push(o);
                }

                deffered.resolve({
                    cols: cols,
                    rows: rows
                });

            }, function (reason) {
                deffered.reject(reason);
            });

            return deffered.promise;
        }

        return {
            getSummary: getSummary,
            getDetail: getDetail,
            getStatistics: getStatistics
        }
    }]);